module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "FMH"
  }, [_vm._v("CHRONOLOGY")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1931   King Alfonso XIII leaves Spain, ushering in the Second Republic, a coalition of Socialists and liberal middle-class Republicans; the new government gives women the vote, legalizes divorce, cuts the size of the army")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1932   General José Sanjurjo attempts a right-wing coup against the Spanish Republic; Anarchist uprisings take place in Andalusia, Aragon, the Basque country, and Madrid")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_vm._v("Franklin Delano Roosevelt elected president of the United States; U.S. unemployment at 25 percent")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1933   Adolf Hitler becomes chancellor of Germany; all political parties except National Socialists (Nazis) are banned; the first Nazi concentration camp is opened at Dachau")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_vm._v("Spanish right-wing parties win a majority in the Cortes")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1934   General Francisco Franco leads suppression of miners’ rebellion in Asturias")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_vm._v("Austrian Civil War causes street fighting in Vienna and other cities; conservative premier Dolfuss outlaws the Social Democrats and Austria becomes a proto-fascist state")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1935   Andrés Nin and Joaquin Maurin form the Workers’ Party of Marxist Unification (POUM) in Catalonia")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_vm._v("Prime Minister Benito Mussolini sends Italian troops to invade Abyssinia")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_vm._v("Stalin initiates the first purge of what will be called the Great Terror")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1936   "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("February")]), _vm._v(" Newly formed Popular Front coalition of Socialists, Communists, and Republicans narrowly wins Spanish general elections; the new government relieves Francisco Franco of his command and posts him to Canary Islands")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("March")]), _vm._v(" Hitler reoccupies the Rhineland")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("May")]), _vm._v(" Popular Front wins general election in France; Léon Blum narrowly escapes assassination by fascist militia, becomes premier")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("July")]), _vm._v(" Concerted military uprisings take place all over Spain; Franco flies from Canary Islands to Morocco to take charge of the Army of Africa and invade the Spanish mainland; the government arms civilians to combat the mutiny")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("August")]), _vm._v(" European nations, joined by the United States, declare a Non-Intervention Agreement for Spain; Nationalist (rebel) army, aided by secret gifts of war materiel from Germany and Italy, advances steadily; Socialist leader Francisco Largo Caballero becomes premier of Spain")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("September")]), _vm._v(" Spanish rebels take Toledo and San Sebastian; Franco is appointed supreme political and military commander of the rebels")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("October")]), _vm._v(" Spanish gold reserves transported to Russia; first International Brigades arrive in Spain")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("November")]), _vm._v(" Nationalist forces advance to outskirts of Madrid, but are halted; government relocates to Valencia; Germany and Italy recognize Franco")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1937   "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("January")]), _vm._v(" Moscow trials of Old Bolsheviks and current army officers begin; U.S. Congress forbids all arms sales to Spain")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("February")]), _vm._v(" Nationalists take Málaga, begin offensive in Jarama Valley")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("March")]), _vm._v(" Government forces push back Nationalists at Guadalajara")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("April")]), _vm._v(" German Luftwaffe bombs Guernica")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("May")]), _vm._v(" May Days in Barcelona; Juan Negrin replaces Largo Caballero as premier")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("June")]), _vm._v(" Bilbao falls to Nationalists")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("July")]), _vm._v(" Battle of Brunete; USSR enters Sino-Japanese War")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("August")]), _vm._v(" Fighting begins on Aragon Front")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("October")]), _vm._v(" Government forces take Belchite in Aragon; Nationalists win control of north; government moves from Valencia to Barcelona")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("December")]), _vm._v(" Teruel offensive begins. In China, Japanese besiege and take Nanking")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1938   "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("January")]), _vm._v(" Government forces take Teruel")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("February")]), _vm._v(" Nationalists retake Teruel")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("March")]), _vm._v(" Nationalists retake Belchite, start drive to Mediterranean; Italian planes begin bombing Barcelona; France reopens border with Spain; Germany annexes Austria in the Anschluss")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("April")]), _vm._v(" Nationalists take Lérida, then Vinaroz, cutting the Republican zone in two; Franco privately signs the Anti-Comintern Pact with Japan, Italy, and Germany")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("June")]), _vm._v(" Léon Blum resigns as French premier and is succeeded by Édouard Daladier; French border with Spain closed")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("July")]), _vm._v(" Spanish government begins counteroffensive along the Ebro")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("September")]), _vm._v(" Munich conference among France, Britain, Germany, and Italy permits Hitler’s annexation of Czech Sudetenland")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("October")]), _vm._v(" Spanish government agrees to withdrawal of all foreign volunteers; International Brigades have farewell parade in Barcelona; in China, Hankow falls to Japanese")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("November")]), _vm._v(" Rio Segre offensive; Battle of the Ebro ends in government defeat and retreat back across river; in Germany, Kristallnacht results in destruction of 7,500 Jewish shops and 400 synagogues")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("December")]), _vm._v(" Franco begins offensive on Catalonia")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL"
  }, [_vm._v("1939   "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("January")]), _vm._v(" Nationalist troops take Barcelona")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("February")]), _vm._v(" Fall of Catalonia; Britain and France recognize Franco")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("March")]), _vm._v(" Franco marches into Madrid; Germany annexes all of Czechoslovakia, demands the free city of Danzig in Poland")]), _vm._v(" "), _c('p', {
    staticClass: "FM2CL-A"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("April")]), _vm._v(" Franco announces the end of military hostilities, makes public his agreement to the German/Italian/Japanese Anti-Comintern Pact")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdb5aa6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chronology.vue
// module id = 75
// module chunks = 0